<script setup>
import { DEV_MODE } from '@/config/dev-mode';

const emit = defineEmits(['submitReport', 'backToList'])

// 선택된 신고 이유
const reportType = ref(null)
// 기타 사유
const reasonText = ref('')
const taRef = ref(null)
// 500자 제한
const MAX_LEN = 500;
const charCount = computed(() => reasonText.value.length)

/** 신고 사유 리스트 */
// TODO: 추후 API 생성 시 value값으로 POST 할 수 있도록, type값은 백엔드 요구 사항에 맞게 수정
const reasonList = [
  { txt: '영리목적 및 홍보성', type: 1 },
  { txt: '비매너 사용자', type: 2 },
  { txt: '개인정보 침해', type: 3 },
  { txt: '욕설  및 인신공격', type: 4 },
  { txt: '음란 및 선정성', type: 5 },
  { txt: '불법정보', type: 6 },
  { txt: '같은  내용 도배', type: 7 },
  { txt: '기타', type: 8 },
]

const selectReason = (reason) =>{
  reportType.value = reportType.value === reason ? null : reason;

}

const submitReport = () =>{
  emit('submitReport', reportType.value)
}

const backToList = () => {
  emit('backToList')
}

/** 기사 사유 입력창 높이 조정 */
function autoResize(e) {
  const el = e?.target || taRef.value
  if (!el) return
  el.style.height = 'auto'
  el.style.height = el.scrollHeight + 'px'
}

onMounted(() => {
  nextTick(() => autoResize())
})
</script>

<template>
  <div class="board-comment__wrapper">
    <div class="comment-report__top">
      <span class="comment-report__top-txt">
        어떤 문제가 있나요?
      </span>
      <span class="comment-report__top-desc">
        신고된 글은 검토후 삭제 처리가 됩니다.<br/>
        아래 사유를 선택하여 안내에 따라 신고 접수를  진행하여 주시기 바랍니다.
      </span>
    </div>

    <div class="comment-report__reason">
      <div
        v-for="(reason, idx) in reasonList"
        :key="idx"
        class="comment-report__reason-list"
        :class="{active: reportType === reason.type}"
        @click="selectReason(reason.type)">
        {{ reason.txt }}
      </div>
      <div
        v-if="reportType === 8"
        class="report-reason__etc">
          <textarea
            ref="taRef"
            v-model="reasonText"
            class="report-input-plain"
            placeholder="구체적인 기타 사유를 입력해주세요"
            rows="1"
            autocapitalize="sentences"
            autocomplete="off"
            autocorrect="off"
            :maxlength="MAX_LEN"
            @input="autoResize"
          />
          <div class="report__input-counter"><span>{{ charCount }}</span> <span class="max-length">/ 500</span></div>
      </div>
    </div>
  </div>
  
  <div class="comment-report__bottom">
    <button 
      class="report__submit-btn"
      @click="submitReport"
    >
      신고하기
    </button>
    <button 
      class="report__cancel-btn"
      @click="backToList"
    >
      취소
    </button>
  </div>

</template>